import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Component que a traves de un array de Allergens muestra su icona
 *
 * Paso a crear:
 * Poder escoger el tamaño del icono
 */

@Component({
  selector: 'comp-name-lang',
  templateUrl: 'name-lang.html',
})
export class NameLangPage {
  @Input() lang;
  @Input() value_es: any;
  @Input() value_ca;
  @Input() value_en;
  @Input() value_de;
  @Input() value_it;
  @Input() value_fr;

  constructor(public navCtrl: NavController, public navParams: NavParams) {

  }
}



// WEBPACK FOOTER //
// ./src/pages/components/name-lang/name-lang.ts